// NewPostNotifier.js
import { connect } from 'react-redux';
import NewPostNotifier from '../component/NewPostNotifier.jsx';
import withRouter from '../component/WithRouter.jsx';

import fetchFeeds from '../action/fetchFeeds.js';
import setMessageExpanded from '../action/setMessageExpanded.js';
import getMessageList from '../selector/getMessageList.js';
import getFeedName from '../selector/getFeedName.js';
import getOperationData from '../selector/getOperationData.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import {
  ProfileListType,
  PROFILE_FEED_REMOTE_CONFIG_KEY_MAP,
} from '../resource/profileConstants.js';
import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';
import { breakpoint } from '../style/variables.js';

const mapStateToProps = (state, { userId, location }) => {
  const isOnPostDetail = getIsMatchedPathname({
    pathname: location?.pathname,
    dataKey: 'isOnPostDetail',
  });
  const isShortVideo = isOnPostDetail;
  const feedNameRemoteConfigKey =
    PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[
      isShortVideo ? ProfileListType.SHORT : ProfileListType.STORY
    ];
  const feedName = getFeedName(
    state,
    feedNameRemoteConfigKey,
    '{USER_ID}',
    userId
  );
  const { intersectedFeedName, feedNameWithQuery } =
    getSelectedQueryOptionObject(
      state,
      feedName,
      getSelectedFeedQueryOptions(state, feedNameRemoteConfigKey, undefined),
      getRemoteConfigData(
        state,
        `${feedNameRemoteConfigKey}_${QueryPrefix[QueryType.SORT]}`
      )?.[0]
    );
  const listPath = [
    'outbox',
    isShortVideo ? ProfileListType.SHORT : ProfileListType.STORY,
    userId,
  ];
  const deviceWidth = getOperationData(state, ['device'], 'width');
  const isOnDesktop = deviceWidth > breakpoint.mobile;
  return {
    intersectedFeedName,
    feedNameWithQuery,
    count: getMessageList(state, 'outbox', listPath, 'totalCount'),
    isShortVideo,
    isOnDesktop,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
    expandBroadcastList: messageId =>
      dispatch(
        setMessageExpanded({ expandedField: 'broadcastList', messageId })
      ),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NewPostNotifier)
);
